import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

declare let google: any;

@Component({
  selector: 'job-invitation-filters-dialog',
  templateUrl: './job-invitation-filters-dialog.component.html',
  styleUrls: ['./job-invitation-filters-dialog.component.scss'],
  providers: []
})
export class JobInvitationFiltersDialogComponent implements OnInit {
  title = 'Filter Jobs';
  loading = false;
  errors = [];
  locations = [];
  locationsConfig = {
    nameProperty: 'name',
    searchable: true,
    loadingOptions: false
  };
  projects = [];
  projectsConfig = {
    nameProperty: 'name',
    searchable: true,
    loadingOptions: false
  };
  customers = [];
  customersConfig = {
    nameProperty: 'name',
    searchable: true,
    loadingOptions: false
  };
  callback;
  model = {};
  dropdownSearch;
  dropdownNextPage;


  constructor(
    public dialogRef: MatDialogRef<JobInvitationFiltersDialogComponent>,
  ) { }

  ngOnInit() {
  }

  onSelect(filterType, e) {
    this.model[filterType] = e;
  }

  submit() {
    this.callback(this.model);
    this.dialogRef.close();
  }
}
